import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { AppointmentState } from './types';

export const getters: GetterTree<AppointmentState, RootState> = {}
